import { createContext, useContext } from "react";

import type { TimeRangePickerContextValue } from "./TimeRangePicker.types";
import {
  DEFAULT_MAJOR_TICK,
  DEFAULT_MAX,
  DEFAULT_MIN,
  DEFAULT_MINOR_TICK,
  DEFAULT_STEP,
  MIN_VIEW,
} from "./constants";
import { toMinutes } from "./timeMath";

const noopTrackRef: TimeRangePickerContextValue["trackRef"] = {
  current: null,
};

const defaultMin = toMinutes(DEFAULT_MIN) ?? 0;
const defaultMax = toMinutes(DEFAULT_MAX) ?? 24 * 60;

export const TimeRangePickerContext =
  createContext<TimeRangePickerContextValue>({
    ranges: [],
    lanes: [],
    min: defaultMin,
    max: defaultMax,
    view: { begin: defaultMin, end: defaultMax },
    minView: MIN_VIEW,
    step: DEFAULT_STEP,
    minDuration: DEFAULT_STEP,
    majorStep: DEFAULT_MAJOR_TICK,
    minorStep: DEFAULT_MINOR_TICK,
    overlap: "forbid",
    disabled: false,
    readOnly: false,
    selectedIndex: null,
    trackRef: noopTrackRef,
    select: () => {},
    setView: () => {},
    zoomAt: () => {},
    panBy: () => {},
    updateRange: () => {},
    addRange: () => -1,
    removeRange: () => {},
    commit: () => {},
    boundsOf: () => ({ begin: defaultMin, end: defaultMax }),
    minutesAt: () => defaultMin,
    percentOf: () => 0,
  });

export function useTimeRangePickerContext(): TimeRangePickerContextValue {
  return useContext(TimeRangePickerContext);
}
